import BaseProxy from '@/proxy/BaseProxy';
import _ from "lodash";
import Axios from "axios";
import {apiServerUrl} from "../plugins/firebase";


class TabelProxy extends BaseProxy {
  constructor(parameters = {}, token) {
    super('', parameters);
    Axios.defaults.baseURL = apiServerUrl;

    this.headers = {
      'Authorization': `Bearer ${localStorage.getItem('api-token')}`
    }
  }

  create(projectId, data = {}) {
    this.setData({
      ...data,
      "projectId": projectId
    });
    return this.submit('post', '/employees');
  }

  update(data = {}) {
    this.setData({
      ...data,
    });
    return this.submit('put', '/employees');
  }

  updateIndex(employeeId, targetId, position = 'after') {
    this.setData({
      elementId: employeeId,
      targetId: targetId,
      position
    });
    return this.submit('put', '/employees/position');
  }


  remove(id ) {
    return this.submit('delete', '/employees/' + id);
  }

  getUser(id) {
    return this.submit('get', '/employees/' + id);
  }

  getTables(projectId, filter) {
    return this.submit('get', 'https://stroybots-firebase-mongo-web.stroybots.ru/api/tabels/list/' + projectId + '?' + new URLSearchParams(filter).toString());
  }


  getTable(id) {
    return this.submit('get', '/timesheets/' + id);
  }

  deleteTabel(id) {
    return this.submit('delete', '/timesheets/' + id);
  }


  createReport(data) {
    this.setData(data)
    return this.submit('post', '/timesheets');
  }

  updateReport(data) {
    this.setData(data)
    return this.submit('put', '/timesheets');
  }


  async list(projectId, companyId, limit = 9999) {
    let query = '?limit=' + limit
    if(companyId) {
      query = '?companyId=' + companyId
    }
    const response = await this.submit('get', '/employees/list/' + projectId + query);
    if(!response) {
      return response
    }

    return {
      ...response,
      data: _.orderBy(response.data, 'index', ['asc'])
    }
  }

  getTimeSheet(projectId, dateFrom, dateTo) {
    let query = ''
    if(dateFrom) {
      query = '?dateFrom=' + dateFrom
    }

    if(dateTo) {
      if(query.length) {
        query += '&dateTo=' + dateTo
      } else {
        query += '?dateTo=' + dateTo
      }
    }


    return  '/timesheets/export/standard/' + projectId + query;
  }

  getFormT12type1(projectId, date, ids, showAll, filters, uid) {
    let query = '?uid=' + uid
    if(date) {
      query = query + '&date=' + date
    }

    if(showAll) {
      query = query + '&showAll=true'
    }


    if(ids && ids.length) {
      const ids_s = ids.map(({value}) => value).join(',');
      query += '&ids=[' + ids_s + ']'
    }


    if(filters && filters.objectsIds && filters.objectsIds.length) {
      const ids_s = filters.objectsIds.map(({value}) => value).join(',');
      query += '&objectsIds=[' + ids_s + ']'
    }

    if(filters && filters.workTypesIds && filters.workTypesIds.length) {
      const ids_s = filters.workTypesIds.map(({value}) => value).join(',');
      query += '&workTypesIds=[' + ids_s + ']'
    }

    if(filters && filters.turns && filters.turns.length) {
      const ids_s = filters.turns.map(({value}) => value).join(',');
      query += '&turns=[' + ids_s + ']'
    }


    return  'https://stroybots-firebase-mongo-web.stroybots.ru/api/tabels/onGenerateFormT12V1Excel/' + projectId + query;
  }

  getFormT12type2(projectId, date, ids, showAll, filters) {
    let query = '?l=1'
    if(date) {
      query = '?date=' + date
    }

    if(showAll) {
      query = query + '&showAll=true'
    }


    if(filters && filters.objectsIds && filters.objectsIds.length) {
      const ids_s = filters.objectsIds.map(({value}) => value).join(',');
      query += '&objectsIds=[' + ids_s + ']'
    }

    if(filters && filters.workTypesIds && filters.workTypesIds.length) {
      const ids_s = filters.workTypesIds.map(({value}) => value).join(',');
      query += '&workTypesIds=[' + ids_s + ']'
    }

    if(filters && filters.turns && filters.turns.length) {
      const ids_s = filters.turns.map(({value}) => value).join(',');
      query += '&turns=[' + ids_s + ']'
    }


    if(ids && ids.length) {
      const ids_s = ids.map(({value}) => value).join(',');
        query += '&ids=[' + ids_s + ']'
    }


    return  '/timesheets/export/formT12type2/' + projectId + query;
  }

  getFormT12type3(projectId, dateFrom, dateTo, ids, showAll, filters) {
    let query = '?l=1'
    if(dateFrom) {
      query = '?dateFrom=' + dateFrom
    }

    if(dateTo) {
      if(query.length) {
        query += '&dateTo=' + dateTo
      } else {
        query += '?dateTo=' + dateTo
      }
    }

    if(showAll) {
      query = query + '&showAll=true'
    }

    if(filters && filters.objectsIds && filters.objectsIds.length) {
      const ids_s = filters.objectsIds.map(({value}) => value).join(',');
      query += '&objectsIds=[' + ids_s + ']'
    }

    if(filters && filters.workTypesIds && filters.workTypesIds.length) {
      const ids_s = filters.workTypesIds.map(({value}) => value).join(',');
      query += '&workTypesIds=[' + ids_s + ']'
    }

    if(filters && filters.turns && filters.turns.length) {
      const ids_s = filters.turns.map(({value}) => value).join(',');
      query += '&turns=[' + ids_s + ']'
    }


    if(ids && ids.length) {
      const ids_s = ids.map(({value}) => value).join(',');
      query += '&ids=[' + ids_s + ']'
    }


    return  '/timesheets/export/form4/' + projectId + query;
  }



  getUsersFromExcel(projectId, companyId) {
    let query = ''

    if(companyId) {
      query = '?companyId=' + companyId
    }

    return  '/employees/export/list/' + projectId + query;
  }


  async importFromExcel({projectId, companyId, deleteEmployees, file}) {
    const formData = new FormData();

    formData.append('projectId', projectId)
    formData.append('companyId', companyId)
    if(deleteEmployees) {
      formData.append('deleteEmployees', deleteEmployees)
    }
    formData.append('file', file)

    this.setData(formData)

    return this.submit('post', '/employees/import/list/')
  }
}

export default TabelProxy;



// WEBPACK FOOTER //
// ./src/proxy/TabelProxy.js